import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import PieChartIcon from "@material-ui/icons/PieChart";
import WalletIcon from "@material-ui/icons/AccountBalanceWallet";

const style = (theme) => ({
  container: {
    display: "flex",
    justifyContent: "center",
    marginTop: "20px",
    marginBottom: "20px",
  },
  toggleGroup: {
    display: "flex",
    borderRadius: "9999px",
    backgroundColor: "#f5f5f5",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
    overflow: "hidden",
  },
  button: {
    width: "160px",
    padding: "8px 24px",
    fontSize: "0.9rem",
    fontWeight: 600,
    border: "none",
    cursor: "pointer",
    transition: "all 0.2s ease-in-out",
    color: "#555",
    backgroundColor: "transparent",
    "&:hover": {
      backgroundColor: "#f7e9ccff",
    },
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    flexDirection: "row",
  },
  activeButton: {
    backgroundColor: "#cca656",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#cca656",
    },
  },
});

const WalletToggleNav = ({ clientId, location, classes, onClick }) => {
  const isBalancingPage = location === "walletBalancings";
  const isPositionPage = location === "walletPositions";

  const handleClick = (path) => {
    if (onClick) {
      onClick(path);
    }
  };

  return (
    <div className={classes.container}>
      <div className={classes.toggleGroup}>
        <button
          onClick={() => handleClick("walletBalancings")}
          className={`${classes.button} ${
            isBalancingPage ? classes.activeButton : ""
          }`}
        >
          <PieChartIcon />
          Enquadramento
        </button>
        <button
          onClick={() => handleClick("walletPositions")}
          className={`${classes.button} ${
            isPositionPage ? classes.activeButton : ""
          }`}
        >
          <WalletIcon />
          Posição
        </button>
      </div>
    </div>
  );
};

export default withStyles(style)(WalletToggleNav);
